export const ID_PRODUCT_IMAGE_ATTRIBUTE = '65f2b6b8b7c9950d87245eaf';
export const ID_TYPE_PRODUCT_ATTRIBUTE = '664472695c22ed91d02ccdbf';
export const ID_NAME_PRODUCT_ATTRIBUTE = '66cf0ad4c586564545d714e4';
export const ID_ARTICLE_ATTRIBUTE = '66cf0b2dc586564545d714ea';
export const ID_AR_LINK_ATTRIBUTE = '71c605d568f8602d88f2ae24';
export const ID_RRC_ATTRIBUTE = '66d6c80acbfb7d6b8bea4b6f';
export const ID_HEIGHT_ATTRIBUTE = '664474bc5c22ed91d02cce15';
export const ID_WIDTH_ATTRIBUTE = '6644749b5c22ed91d02cce0c';
export const ID_DEPTH_ATTRIBUTE = '664474cc5c22ed91d02cce1e';
export const ID_COLLECTION_ATTRIBUTE = '661d31bd9ee5d643bc19d5fe';
export const ID_FACADE_MATERIAL_ATTRIBUTE = '6644949b5c22ed91d02cd002';
export const ID_BODY_MATERIAL_ATTRIBUTE = '66448de45c22ed91d02ccf20';
export const ID_DESCRIPTION_ATTRIBUTE = '661d314c9ee5d643bc19d5d8';
export const ID_INSTALLATION_ATTRIBUTE = '664496735c22ed91d02cd0c9';
export const ID_VIEW_MIRRORS_ATTRIBUTE = '672b24201ed2d906e2589dcc';
export const ID_PEDESTAL_ATTRIBUTE = '664472695c22ed91d02ccdbf'; //Проверить
export const ID_MIRRORS_ATTRIBUTE = '672b24201ed2d906e2589dcc';
export const ID_CLOSET_ATTRIBUTE = '664472695c22ed91d02ccdbf'; //Проверить
export const ID_COLOR_ATTRIBUTE = '6644977c5c22ed91d02cd14f';
export const ID_SUBCATEGORY_ATTRIBUTE = '66fb8b0fc5c96dcaa2c03016';
export const ID_SCHEMES_ATTRIBUTE = '661d31879ee5d643bc19d5ec';
export const ID_PASSPORT_ATTRIBUTE = '661d317c9ee5d643bc19d5e3';
export const ID_FACADE_COVERING_ATTRIBUTE = '664494bb5c22ed91d02cd014';
export const ID_PRESENCE_CLOSER_ATTRIBUTE = '664496a05c22ed91d02cd0db';
export const ID_INSTRUCTION_ATTRIBUTE = '664c59543ed5ed6f32f2b6ca';
export const ID_REMAINDER_ATTRIBUTE = '6836f1cf531aad4a82eb8238';
export const ID_ACTUAL_ATTRIBUTE = '67c9a1e89e71b3441b802836';
export const ID_BRAND_ATTRIBUTE = '661d31a69ee5d643bc19d5f5';
export const ID_INFOGRAPHICS_ATTRIBUTE = '664afe7d3ed5ed6f32f2b248';
export const ID_SEO_NAME_ATTRIBUTE = '68f8d06f73def4d77d422498';
export const ID_HEIGHT_WITH_LEGS_ATTRIBUTE = '664493615c22ed91d02ccfc2';
export const ID_HEIGHT_WITH_SINK_ATTRIBUTE = '664493785c22ed91d02ccfcb';
export const ID_TOTAL_NET_WEIGHT_ATTRIBUTE = '664474e05c22ed91d02cce27';
export const ID_COUNTRY_ATTRIBUTE = '664496ea5c22ed91d02cd114';
export const ID_GUARANTEE_ATTRIBUTE = '664493075c22ed91d02ccfad';
export const ID_HOUSING_COATING_ATTRIBUTE = '664494415c22ed91d02ccfe7';
export const ID_HOUSING_SURFACE_ATTRIBUTE = '6644946e5c22ed91d02ccff9';
export const ID_FACADE_SURFACE_ATTRIBUTE = '664494fb5c22ed91d02cd032';
export const ID_FACIAL_FITTINGS_ATTRIBUTE = '664495f85c22ed91d02cd08d';
export const ID_COLOR_FRONT_FITTINGS_ATTRIBUTE = '6644960a5c22ed91d02cd096';
export const ID_STORAGE_SYSTEM_ATTRIBUTE = '664496d45c22ed91d02cd0f9';
export const ID_PUSH_TO_OPEN_ATTRIBUTE = '664496b45c22ed91d02cd0e4';
export const ID_ORIENTATION_OF_DOORS_ATTRIBUTE = '664496825c22ed91d02cd0d2';
export const ID_LAUNDRY_BASKET_ATTRIBUTE = '664495e55c22ed91d02cd07f';
export const ID_MIRROR_SHAPE_ATTRIBUTE = '67346cbb1ed2d906e258aab7';
export const ID_BACKLIGHT_ATTRIBUTE = '66448e035c22ed91d02ccf29';
export const ID_BACKLIGHT_TYPE_ATTRIBUTE = '66448e0c5c22ed91d02ccf32';
export const ID_SWITCH_TYPE_ATTRIBUTE = '66448e7e5c22ed91d02ccf71';
export const ID_BACKLIGHT_BRIGHTNESS_ATTRIBUTE = '65f061b8e6fcc73e7064d2c2';
export const ID_LAMP_TYPE_ATTRIBUTE = '66448e725c22ed91d02ccf68';
export const ID_COLOR_TEMPERATURE_ATTRIBUTE = '66448e865c22ed91d02ccf7a';
export const ID_ANTI_FOG_MIRROR_ATTRIBUTE = '66448e3e5c22ed91d02ccf4d';
export const ID_DEFOGGER_SIZE_ATTRIBUTE = '66448e535c22ed91d02ccf56';
export const ID_MIRROR_OPTIONS_ATTRIBUTE = '664492ef5c22ed91d02ccfa4';
export const ID_SUPPLY_POWER_ATTRIBUTE = '664492dc5c22ed91d02ccf9b';
// export const ID_ADVANTAGES_ATTRIBUTE = '6901eea1c4553047f95918fb';
export const ID_ADVANTAGES_ATTRIBUTE = '6912d55e73def4d77d431ff2';
export const ID_BODY_COLOR_ATTRIBUTE = '6901e3a773def4d77d428bdb';
export const ID_STATUS_ATTRIBUTE = '66f27137cbfb7d6b8bea4bc8';
export const ID_BARCODE_ATTRIBUTE = '66cf0b60c586564545d714f0';
export const ID_CLIENTS_PHOTO_ATTRIBUTE = '696e340eb41c7a37ceea89e0';
// export const ID_CLIENTS_PHOTO_ATTRIBUTE = '696e3494ba4f42bb58d025f8';
export const ID_PRODUCT_VIDEO_ATTRIBUTE = '69a01a52b41c7a37cef1c521';
export const ID_MATCHING_SINKS = '6978901eb41c7a37ceed0740';

export const ID_WB_LINK = 'a3f98f04e72260bb4bb0fb73';
export const ID_OZON_LINK = 'f066aca64976723236ff9679';
export const ID_YANDEX_MARKET_LINK = '367e7a4c001cb7ee3bb8a04e';
